import { createApp } from 'vue';
import LitDiscovery from 'lit-discovery';
import searchComponent from './vue/search.vue';
import * as searchConfig from './search-app-config';

const app = createApp(searchComponent);

app.use(LitDiscovery, {
  fields: searchConfig.fields,  // required. see fields-example.js
  searchOpts: searchConfig.searchOpts,  // required. see config-example.js
  searchApp: app,  // vue entry point. optional (search-base.vue by default)
  // el: '#search-app', // attach vue app to. optional ('#search-app' by default)
})

app.config.compilerOptions.whitespace = 'condense';

window.onload = ()=>{
  app.mount('#search-app');
}
